import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherWall, UpdateWeatherWallDto } from 'types';

export const updateWeatherWall = ({
  data,
  wallId,
}: {
  data: UpdateWeatherWallDto;
  wallId: number;
}): Promise<WeatherWall> => {
  return axios.put(`/api/weather/walls/${wallId}`, data);
};

type UseUpdateWeatherWallOptions = {
  config?: MutationConfig<typeof updateWeatherWall>;
};

export const useUpdateWeatherWall = ({
  config,
}: UseUpdateWeatherWallOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherWalls) {
        queryClient.setQueryData(
          ['weatherWalls'],
          context.previousWeatherWalls
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherWalls']);
    },
    ...config,
    mutationFn: updateWeatherWall,
  });
};
